import { FIRM } from "@/lib/site";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer id="contact-footer" data-testid="site-footer" className="bg-[#0A1128] bg-noise relative pt-24 pb-10">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
      <h2 className="font-serif-display text-white text-[16vw] md:text-[11vw] leading-[0.85] tracking-tight">
        Let&rsquo;s <span className="italic text-[#D4AF37]">Talk.</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-20 border-t border-white/10 pt-12">
        <div>
          <div className="overline text-[#D4AF37] mb-4">Office</div>
          <p className="font-body text-white/75 text-base flex gap-3">
            <MapPin size={18} className="text-[#D4AF37] shrink-0 mt-1" />{FIRM.address}
          </p>
        </div>
        <div>
          <div className="overline text-[#D4AF37] mb-4">Call</div>
          <a href={`tel:+${FIRM.mobileIntl}`} data-testid="footer-phone"
            className="font-body text-white/75 text-base flex gap-3 hover:text-white transition-colors">
            <Phone size={18} className="text-[#D4AF37] shrink-0 mt-1" />+91 {FIRM.mobile}
          </a>
        </div>
        <div>
          <div className="overline text-[#D4AF37] mb-4">Email</div>
          <a href={`mailto:${FIRM.email}`} data-testid="footer-email"
            className="font-body text-white/75 text-base flex gap-3 hover:text-white transition-colors break-all">
            <Mail size={18} className="text-[#D4AF37] shrink-0 mt-1" />{FIRM.email}
          </a>
        </div>
      </div>

      <a href={`https://wa.me/${FIRM.mobileIntl}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
        className="inline-flex items-center gap-3 mt-12 border border-[#D4AF37]/40 text-[#D4AF37] px-6 py-3 hover:bg-[#D4AF37] hover:text-[#0A1128] transition-colors">
        <MessageCircle size={18} /> Chat on WhatsApp
      </a>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-20 pt-8 border-t border-white/10">
        <p className="font-body text-white/45 text-sm">&copy; {new Date().getFullYear()} {FIRM.name}. All rights reserved.</p>
        <p className="font-mono-meta text-white/35 text-xs">advocatearjunsingh.com</p>
      </div>
    </div>
  </footer>
);
